// extracted by mini-css-extract-plugin
module.exports = {"root":"SortableItem_root__yVOFi","dragIcon":"SortableItem_dragIcon__3yITN","disabled":"SortableItem_disabled__Z8XfG"};